import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from './../../shared';

@Component({
  selector: 'about-landing',
  template: require('./about-landing.component.html'),
  styles: [require('./about-landing.component.scss')]
})
export class AboutLandingComponent implements AfterViewInit {
  constructor(private route: ActivatedRoute, private seo: SeoService) {
    // Do stuff
  }

  title = 'About Us - Linescape';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';

  modal: {
    isVisible: boolean;
    title: string;
    body: string;
  } = { isVisible: false, title: '', body: '' };

  ngAfterViewInit() {
    this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }

  openDavidModal() {
    this.modal.title = `David Tarizzo`;
    this.modal.body = `David Tarizzo is co-Founder, and President and CEO of Linescape. David’s extensive business development expertise and proven track record of turning opportunities and ideas into successful global business endeavors led to the inception of Linescape. Prior to co-founding Linescape, David held leadership positions in organizations across Europe and the USA. David also founded an international business that focused on shipping containers for specialty chemical products. David has a degree in chemistry from the University of Illinois and an MBA from the University of Michigan. David has lived in France and England, and currently resides near Chicago, Illinois. In his free time David likes to bike, sail, ski and play tennis.`
    this.modal.isVisible = true;
  }

  openDimitriosModal() {
    this.modal.title = `Dimitrios Sogas`;
    this.modal.body = `Dimitrios Sogas is co-Founder of Linescape and serves as the company’s Vice President and Managing Director. With more than 25 years of executive-level experience in the aerospace and commercial semiconductor industries, Dimitrios’ technological expertise combined with his keen business acumen shaped the architecture and design of Linescape’s unique platform. His big picture outlook and strategic approach to business solutions have been utilized by high-profile organizations around the world, and now at Linescape. Dimitrios holds a degree in electrical engineering from the University of Missouri and an MBA from Santa Clara University. Dimitrios lives in sunny Burlingame, California and enjoys skiing, cycling, cooking, travelling, and collecting and tasting good wine.`
    this.modal.isVisible = true;
  }

  closeModal() {
    this.modal.isVisible = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/about-landing/about-landing.component.ts